import React, { useState, useEffect, useRef, useContext } from 'react';
import './ProPilotActive.scss';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import Header from '@/v2/components/application/Header';
import TimelineText from '@/v2/components/atoms/TimelineText';
import Fade from '@/v2/components/atoms/Fade';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { DriverAssistContext } from '@/v2/state/providers';
import { MomentStateContext } from '@/v2/state/momentState';
import { ClearMemory } from '@/v2/components/utils/DeviceUtils';
import { timeout, clearTimeouts } from '@/v2/components/utils/Timeout';

let videoController = null;

const FADE_TIME = 1000;

const STATE = {
    none: 'none',
    intro: 'intro',
    fade: 'fade',
    end: 'end',
};

const videoReady = (controller, setTime, onReady, cb) => {
    videoController = controller;

    let calledOnce = false;

    videoController.AddOnTimeUpdated(() => {
        setTime(videoController.GetTime());

        const fadeOutTime = videoController.video.duration - FADE_TIME / 1000;

        if (!calledOnce && videoController.GetTime() > fadeOutTime) {
            calledOnce = true;
            cb();
        }
    });

    onReady();
};

const stateIntro = () => {
    videoController.Play();
};

export default ({ isActive, data, onFinished, onReady }) => {
    const [state, setState] = useState(STATE.none);
    const [{ disclaimer }] = useContext(DriverAssistContext);
    const { dispatch: momentDispatch } = useContext(MomentStateContext);

    const time = useRef(TimelineText.Time());

    const stateFade = (cb) => {
        timeout(() => cb(), FADE_TIME);
    };

    useEffect(() => () => clearTimeouts(), []);

    useEffect(() => {
        if (isActive && videoController) {
            videoController.ProgressDispatch(momentDispatch);
            setState(STATE.intro);
        }
    }, [isActive, videoController]);

    useEffect(() => {
        switch (state) {
            case STATE.intro:
                stateIntro();
                break;
            case STATE.fade:
                // delaying execution till video playback finishes
                timeout(() => {
                    stateFade(() => setState(STATE.end));
                }, 800);
                break;
            case STATE.end:
                onFinished();
                ClearMemory();
                break;
            default:
        }
    }, [state]);

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => videoReady(controller, time.current.Set, onReady, () => setState(STATE.fade)),
        autoPlay: true,
    };

    const disclaimerContent = disclaimer ? <Disclaimer data={disclaimer} dark /> : '';

    return (
        <div className="ProPilotActive">
            <VideoSimple src={data.video} options={options} />
            <Header show={isActive} hideLogo dark />
            <TimelineText data={data.text.timeline} time={time.current} background="dark" color="black" />
            <Fade show={state === STATE.fade || state === STATE.end} light cover />
            {disclaimerContent}
        </div>
    );
};
